import { justForSideEffect, justForSideEffectWithPayload } from 'src/infrastructure/saga.helpers'
import {
  CheckRemotePrinterHealthPayload, GetActivePrintersPayload, PrintersManagementState, SaveLocalPrinterSettingsPayload, SetProperty,
} from './PrintersManagementTypes'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export const initialState: PrintersManagementState = {
  isRaspberrySoulConnected: false,
  localPrinter: undefined,
  printers: [],
}

const getLocalPrinter = justForSideEffect()
const getActivePrinters = justForSideEffectWithPayload<GetActivePrintersPayload>()
const saveLocalPrinterSettings = justForSideEffectWithPayload<SaveLocalPrinterSettingsPayload>()
const checkRemotePrinterHealth = justForSideEffectWithPayload<CheckRemotePrinterHealthPayload>()

const setProperty = (
  state: PrintersManagementState,
  action: PayloadAction<SetProperty>,
): PrintersManagementState => {
  const { property, value } = action.payload

  return {
    ...state,
    [property]: value,
  }
}

const clearState = (): PrintersManagementState => initialState

const slice = createSlice({
  name: 'printersManagement',
  initialState,
  reducers: {
    getLocalPrinter,
    getActivePrinters,
    saveLocalPrinterSettings,
    checkRemotePrinterHealth,
    setProperty,
    clearState,
  },
})

export default slice.reducer

export const { actions } = slice
